import React from 'react';
import { Button } from 'reactstrap';
import { history } from '../../../../../../../helpers/history';
import './ArticleMenu.css'
class ArticleMenu extends React.Component {
    state = {
        media: [],
        editMode: false,
        headerImage: ""
    }
    render() {
        return (
            <div>
                <div className="create-article-card">
                    <Button className="floating-add-btn" onClick={() => {
                        history.push('/articles/edit')
                    }}>
                        <i className="fa fa-plus " />
                    </Button>
                    <p>Skapa en ny artikel</p>
                </div>
            </div>
        )
    }
}
export default ArticleMenu;
